import {ExternalLinkHandlerBase} from "../external-link-handler-base";
import {IContactUsExternalLinkHandler} from "./contact-us.external-link-handler.interface";

export class ContactUsExternalLinkHandler extends ExternalLinkHandlerBase implements IContactUsExternalLinkHandler {
    async openContactUs(): Promise<void> {
        const url = await this._getGnwpUrl();
        this._openInNewTab(url);
    }

    protected async _getGnwpUrl(): Promise<string> {
        return await (await this.services.gnwp).getContactUsUrl();
    }
}